// extracted by mini-css-extract-plugin
module.exports = {"promos-badge":"promo-badge_promos-badge__amQge","promos-badge__extra-margin":"promo-badge_promos-badge__extra-margin__lQhC9"};